import ChatMessagesList  from './ChatMessagesList';

export default ChatMessagesList;
